import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeTicketCreateModal } from '../../../../../actions/ui';
import { TaskCreateScreen } from '../TaskCreateScreen';

export const TicketCreateModal = () => {
    const dispatch = useDispatch();
    const { ticketCreateModalOpen } = useSelector((state) => state.ui);

    const handleClose = () => {
        dispatch(closeTicketCreateModal());
    };

    if (!ticketCreateModalOpen) {
        return null;
    }

    return (
        <>
            <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
                <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Nuevo ticket</h5>
                            <button type="button" className="btn-close" aria-label="Cerrar" onClick={handleClose} />
                        </div>
                        <div className="modal-body p-3">
                            <TaskCreateScreen asModal onClose={handleClose} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" />
        </>
    );
};
